import React, { useState, useEffect, useMemo } from 'react';
import { Card, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { SessionsList, createAuthApi } from '@zero/auth-admin-ui';

export function SessionsPage({ axios }) {
  const api = useMemo(() => createAuthApi(axios), [axios]);
  const { t } = useTranslation();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = () => {
    setLoading(true);
    api.listMySessions().then((r) => setSessions(r.data?.Data ?? [])).finally(() => setLoading(false));
  };
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, []);

  const handleRevoke = async (id) => {
    try { await api.revokeMySession(id); message.success(t('sessions.revoke')); refresh(); }
    catch (err) { message.error(err.message); }
  };
  const handleRevokeAll = async () => {
    try { await api.revokeAllMySessions(); message.success(t('sessions.revokeAll')); refresh(); }
    catch (err) { message.error(err.message); }
  };

  return <SessionsList sessions={sessions} loading={loading} onRevoke={handleRevoke} onRevokeAll={handleRevokeAll} scrollY="calc(100vh - 170px)" />;
}
